// 引入文件
import { Utils } from 'k7-components';
import apiConfig, { headers } from './apiConfig'

const { team } = apiConfig
const request = Utils.requset
const Actions = {}
Actions.getGame = (args, loading = 'body') => {
  const url = team.getGame;
  return request.ajaxPromise(url, args, 'get', {
    headers,
    loading,
  })
}

Actions.teams = (args, loading = 'body') => {
  const url = team.teams;
  return request.ajaxPromise(url, args, 'get', {
    headers,
    loading,
  })
}
Actions.checkApply = (args, loading = 'body') => {
  const url = team.checkApply;
  return request.ajaxPromise(url, args, 'get', {
    headers,
    loading,
  })
}

Actions.userInfo = (args, loading = 'body') => {
  const url = team.userInfo;
  return request.ajaxPromise(url, args, 'get', {
    headers,
    loading,
  })
}

Actions.createTeam = (args, loading = 'body') => {
  const url = team.createTeam;
  return request.ajaxPromise(url, args, 'post', {
    contentType: 'json',
    headers,
    loading,
  })
}

Actions.getTeamDetail = (args, loading = 'body') => {
  const url = team.getTeamDetail(args.id);
  delete args.id
  return request.ajaxPromise(url, args, 'get', {
    // contentType: 'json',
    headers,
    loading,
  })
}

Actions.getMemberReward = (args, loading = 'body') => {
  const url = team.getMemberReward(args.id);
  delete args.id
  return request.ajaxPromise(url, args, 'get', {
    // contentType: 'json',
    headers,
    loading,
  })
}
Actions.postMemberReward = (args, loading = 'body') => {
  const url = team.postMemberReward(args.id);
  delete args.id
  return request.ajaxPromise(url, args, 'post', {
    contentType: 'json',
    headers: { action: 'receive', ...headers },
    loading,
  })
}

Actions.joinTeam = (args, loading = 'body') => {
  const url = team.getTeamDetail(args.id);
  delete args.id
  return request.ajaxPromise(url, args, 'post', {
    contentType: 'json',
    headers,
    loading,
  })
}

Actions.getTeamRank = (args, loading = 'body') => {
  const url = team.getTeamRank(args.id);
  delete args.id
  return request.ajaxPromise(url, args, 'get', {
    // contentType: 'json',
    headers,
    loading,
  })
}

Actions.getTeamBaseInfo = (args, loading = 'body') => {
  const url = team.getTeamBaseInfo(args.id);
  delete args.id
  return request.ajaxPromise(url, args, 'get', {
    // contentType: 'json',
    headers,
    loading,
  })
}

Actions.putTeamBaseInfo = (args, formData, loading = 'body') => {
  const url = team.putTeamBaseInfo(args.id);
  return request.ajaxPromise(url, formData, 'post', {
    formData: true,
    headers: { action: 'update', ...headers },
    loading,
  })
}

Actions.putTeamBulletin = (args, loading = 'body') => {
  const url = team.putTeamBulletin(args.id);
  delete args.id
  return request.ajaxPromise(url, args, 'put', {
    contentType: 'json',
    headers: { action: 'update', ...headers },
    loading,
  })
}

Actions.getTeamDonateInfo = (args, loading = 'body') => {
  const url = team.getTeamDonateInfo(args.id);
  delete args.id
  return request.ajaxPromise(url, args, 'get', {
    // contentType: 'json',
    headers,
    loading,
  })
}

Actions.getTeamDonateLog = (args, loading = 'body') => {
  const url = team.getTeamDonateLog(args.id);
  delete args.id
  return request.ajaxPromise(url, args, 'get', {
    // contentType: 'json',
    headers,
    loading,
  })
}

Actions.putBuildTeam = (args, loading = 'body') => {
  const url = team.putBuildTeam(args.id);
  delete args.id
  return request.ajaxPromise(url, args, 'put', {
    contentType: 'json',
    headers: { action: 'update', ...headers },
    loading,
  })
}

Actions.putRemoveMenber = (args, loading = 'body') => {
  const url = team.putRemoveMenber(args.id);
  delete args.id
  return request.ajaxPromise(url, args, 'put', {
    contentType: 'json',
    headers,
    loading,
  })
}

Actions.getMemberList = (args, loading = 'body') => {
  const url = team.getMemberList(args.id);
  delete args.id
  return request.ajaxPromise(url, args, 'get', {
    headers,
    loading,
  })
}

Actions.putChangeJob = (args, loading = 'body') => {
  const url = team.putChangeJob(args.id);
  delete args.id
  return request.ajaxPromise(url, args, 'put', {
    contentType: 'json',
    headers: { action: 'update', ...headers },
    loading,
  })
}

Actions.getApplyList = (args, loading = 'body') => {
  const url = team.getApplyList(args.id);
  delete args.id
  return request.ajaxPromise(url, args, 'get', {
    headers,
    loading,
  })
}

Actions.getTeamGoodsList = (args, loading = 'body') => {
  const url = team.getTeamGoodsList(args.id);
  delete args.id
  return request.ajaxPromise(url, args, 'get', {
    headers,
    loading,
  })
}

Actions.getExpandInfo = (args, loading = 'body') => {
  const url = team.getExpandInfo(args.id);
  delete args.id
  return request.ajaxPromise(url, args, 'get', {
    headers,
    loading,
  })
}

Actions.putExpandInfo = (args, loading = 'body') => {
  const url = team.putExpandInfo(args.id);
  delete args.id
  return request.ajaxPromise(url, args, 'put', {
    contentType: 'json',
    headers: { action: 'update', ...headers },
    loading,
  })
}

Actions.postApplyUser = (args, loading = 'body') => {
  const url = team.postApplyUser(args.id);
  delete args.id
  return request.ajaxPromise(url, args, 'post', {
    contentType: 'json',
    headers: { action: 'approve', ...headers },
    loading,
  })
}

Actions.postAwardDistribution = (args, loading = 'body') => {
  const url = team.postAwardDistribution(args.id);
  delete args.id
  return request.ajaxPromise(url, args, 'post', {
    contentType: 'json',
    headers: { action: 'give', ...headers },
    loading,
  })
}
Actions.getTeamRewardList = (args, loading = 'body') => {
  const url = team.getTeamRewardList(args.id);
  delete args.id
  return request.ajaxPromise(url, args, 'get', {
    // contentType: 'json',
    headers,
    loading,
  })
}
Actions.putTeamReward = (args, loading = 'body') => {
  const url = team.putTeamReward(args.id);
  delete args.id
  return request.ajaxPromise(url, args, 'put', {
    contentType: 'json',
    headers: { action: 'receive', ...headers },
    loading,
  })
}

Actions.getCity = (args, loading = 'body') => {
  const url = team.getCity
  return request.ajaxPromise(url, args, 'get', {
    headers,
    loading,
  })
}

Actions.getTeamGame = (args, loading = 'body') => {
  const url = team.getTeamGame
  return request.ajaxPromise(url, args, 'get', {
    headers,
    loading,
  })
}

Actions.getTeamScore = (args, loading = 'body') => {
  const url = team.getTeamScore
  return request.ajaxPromise(url, args, 'get', {
    headers,
    loading,
  })
}

Actions.getUserScore = (args, loading = 'body') => {
  const url = team.getUserScore
  return request.ajaxPromise(url, args, 'get', {
    headers,
    loading,
  })
}

Actions.getScoreDetail = (args, loading = 'body') => {
  const url = team.getScoreDetail
  return request.ajaxPromise(url, args, 'get', {
    headers,
    loading,
  })
}

Actions.putQuitTeam = (args, loading = 'body') => {
  const url = team.putQuitTeam(args.id)
  delete args.id
  return request.ajaxPromise(url, args, 'put', {
    contentType: 'json',
    headers,
    loading,
  })
}
export default Actions
